import { CheckCircle2, Truck, Users, Award } from "@/components/Icon";

const usps = [
  { icon: Award, text: "Professionele kwaliteit" },
  { icon: CheckCircle2, text: "Vanaf 10 stuks" },
  { icon: Users, text: "Bedrijven, verenigingen, evenementen & particulieren" },
  { icon: Truck, text: "Snelle levering, scherpe prijzen" },
];

const USPBar = () => (
  <section className="bg-primary text-primary-foreground py-5">
    <div className="container">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-3">
        {usps.map((u) => (
          <div key={u.text} className="flex items-center gap-3 text-sm font-medium">
            <u.icon className="w-5 h-5 flex-shrink-0" />
            <span>{u.text}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default USPBar;
